import React from 'react';
import { INK, GREY, BORDER, RED, FONT } from '../../routes/seo/SeoUI';

// Reusable FAQ accordion. `preview` (number) limits how many show; omit to show all.
class FaqAccordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: null };
  }

  render() {
    const { items = [], preview } = this.props;
    const list = preview ? items.slice(0, preview) : items;
    const { open } = this.state;
    return (
      <div style={{ fontFamily: FONT }}>
        {list.map((f, i) => (
          <div key={i} style={{ borderBottom: `1px solid ${BORDER}` }}>
            <button
              type="button"
              onClick={() => this.setState({ open: open === i ? null : i })}
              style={{
                width: '100%', textAlign: 'left', background: 'none', border: 'none',
                padding: '16px 4px', cursor: 'pointer', display: 'flex',
                justifyContent: 'space-between', alignItems: 'center',
                fontSize: 16, fontWeight: 600, color: INK, fontFamily: FONT,
              }}
              aria-expanded={open === i}
            >
              <span>{f.q}</span>
              <span style={{ color: RED, marginLeft: 12, fontSize: 22, lineHeight: 1 }}>{open === i ? '−' : '+'}</span>
            </button>
            {open === i && (
              <div style={{ padding: '0 4px 18px', color: GREY, lineHeight: 1.6, fontSize: 15 }}>{f.a}</div>
            )}
          </div>
        ))}
      </div>
    );
  }
}

export default FaqAccordion;
